export default __webpack_public_path__ + "static/media/Perfil-administrador.1ed36d87.png";